import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { propTypes } from '../../util/types';
import { Form, FieldBoolean, FieldTextInput, PrimaryButton } from '../../components';
import css from './EditListingPoliciesForm.css';

const EditListingPoliciesFormComponent = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        className,
        disabled,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateError,
        updateInProgress,
      } = fieldRenderProps;

      const rulesLabel = intl.formatMessage({ id: 'EditListingPoliciesForm.rules.label' });
      const rulesPlaceholder = intl.formatMessage({ id: 'EditListingPoliciesForm.rules.placeholder' });
      const suitableForChildrenLabel = intl.formatMessage({ id: 'EditListingPoliciesForm.suitableForChildren.label' });
      const suitableForChildrenInformation = intl.formatMessage({ id: 'EditListingPoliciesForm.suitableForChildren.information' });
      const eventLabel = intl.formatMessage({ id: 'EditListingPoliciesForm.event.label'});
      const eventInformation =  intl.formatMessage({ id: 'EditListingPoliciesForm.event.information' })
      const alcoholLabel = intl.formatMessage({ id: 'EditListingPoliciesForm.alcohol.label'});
      const smokeLabel = intl.formatMessage({ id: 'EditListingPoliciesForm.smoke.label'});
      const petsLabel = intl.formatMessage({ id: 'EditListingPoliciesForm.pet.label'});
      const musicLabel = intl.formatMessage({ id: 'EditListingPoliciesForm.music.label'});

      const errorMessage = updateError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingPoliciesForm.updateFailed" />
        </p>
      ) : null;

      const classes = classNames(css.root, className);
      const submitReady = updated && pristine;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          <FieldBoolean
            className={css.policiesItem}
            id="suitableForChildren"
            name="suitableForChildren"
            label={suitableForChildrenLabel}
            informationTooltipContent={suitableForChildrenInformation}
            variant="button"
          />
          <FieldBoolean
            className={css.policiesItem}
            id="policyEvent"
            name="policyEvent"
            label={eventLabel}
            informationTooltipContent={eventInformation}
            variant="button"
          />
          <FieldBoolean
            className={css.policiesItem}
            id="policyAlcohol"
            name="policyAlcohol"
            label={alcoholLabel}
            variant="button"
          />
          <FieldBoolean
            className={css.policiesItem}
            id="policySmoking"
            name="policySmoking"
            label={smokeLabel}
            variant="button"
          />
          <FieldBoolean
            className={css.policiesItem}
            id="policyPets"
            name="policyPets"
            label={petsLabel}
            variant="button"
          />
          <FieldBoolean
            className={css.policiesItem}
            id="policyMusic"
            name="policyMusic"
            label={musicLabel}
            variant="button"
          />
          <FieldTextInput
            id="rules"
            name="rules"
            className={css.policy}
            type="textarea"
            label={rulesLabel}
            placeholder={rulesPlaceholder}
          />
          <div className={css.buttonContainer}>
            <PrimaryButton
              className={css.submitButton}
              type='submit'
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </PrimaryButton>
          </div>
        </Form>
      );
    }}
  />
);

EditListingPoliciesFormComponent.defaultProps = {
  updateError: null,
};

const { func, string, bool } = PropTypes;

EditListingPoliciesFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  updated: bool.isRequired,
  updateError: propTypes.error,
  updateInProgress: bool.isRequired,
};

export default compose(injectIntl)(EditListingPoliciesFormComponent);



// WEBPACK FOOTER //
// ./src/forms/EditListingPoliciesForm/EditListingPoliciesForm.js